import { render } from "./MultiSelectWithOther.vue?vue&type=template&id=afa77cb2&scoped=true"
import script from "./MultiSelectWithOther.vue?vue&type=script&lang=js"
export * from "./MultiSelectWithOther.vue?vue&type=script&lang=js"

import "./MultiSelectWithOther.vue?vue&type=style&index=0&id=afa77cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afa77cb2"]])

export default __exports__